(() => {
  if (window.KbdLootlyFooterButtonInitialized) return;
  window.KbdLootlyFooterButtonInitialized = true;

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-kbd-lootly-open]");
    if (!button) return;

    event.preventDefault();

    if (typeof window.openLootlyWidget === "function") {
      window.openLootlyWidget(event);
      return;
    }

    const lootlyUrl = new URL(window.location.href);
    lootlyUrl.searchParams.set("lourl", "open");
    window.location.assign(lootlyUrl.toString());
  });
})();
